import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { useState as h } from "react";
import f from "../../form-elements/dynamic-form/dynamic-form.js";
import g from "./forms-block-wrapper.js";
import { usePostEdiInvoiceServiceNow as k } from "../../../react-query-queries/customer-service/use-post-customer-service-service-now.js";
import { getErrorsFromApiError as y } from "../../../helpers/form-helper.js";
import { isArrayWithItems as x } from "../../../helpers/array-helper.js";
import "dayjs";
const b = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "edi-content",
      value: /* @__PURE__ */ e("h2", { className: "h4", children: "Anmäl EDI-faktura" })
    },
    {
      type: "text",
      name: "orgno",
      label: "Organisationsnummer*",
      helperText: "Tio siffror utan bindestreck",
      rules: { required: !0 }
    },
    {
      type: "text",
      name: "customerNumber",
      label: "Kundnummer"
    },
    {
      type: "text",
      name: "efakturaGlnOrg",
      label: "E-faktura adress, GLN eller org.nummer*",
      rules: { required: !0 }
    },
    {
      type: "text",
      name: "operator",
      label: "Operatör"
    },
    {
      type: "content",
      name: "contact-heading",
      value: /* @__PURE__ */ e("h2", { className: "h4", children: "Kontaktuppgifter" })
    },
    {
      type: "text",
      name: "firstName",
      label: "Förnamn",
      autoComplete: "given-name",
      rules: { required: !0 }
    },
    {
      type: "text",
      name: "lastName",
      label: "Efternamn",
      autoComplete: "family-name",
      rules: { required: !0 }
    },
    {
      type: "text",
      name: "email",
      label: "E-post*",
      autoComplete: "email",
      rules: { required: !0 }
    },
    {
      type: "text",
      name: "phone",
      label: "Telefonnummer eller mobil",
      autoComplete: "tel"
    }
  ]
}, T = ({ title: m, preamble: r }) => {
  const [s, t] = h(), { isPending: a, mutateAsync: i } = k();
  return /* @__PURE__ */ n(g, { children: [
    /* @__PURE__ */ n("div", { className: "text-max-width", children: [
      /* @__PURE__ */ e("h3", { children: m }),
      r && /* @__PURE__ */ e("div", { children: r })
    ] }),
    /* @__PURE__ */ e("div", { className: "form-max-width", children: /* @__PURE__ */ e(
      f,
      {
        form: b,
        onFormSubmit: (l, { reset: d }) => {
          const { terms: F, ...u } = l, c = {
            ...u,
            requestType: "Edi-Invoice"
          };
          i(c).then(() => {
            t({
              type: "success",
              heading: "Ditt ärende är skickat",
              messages: [
                {
                  text: "Ditt supportärende är nu registrerat hos oss. Vi arbetar med att hantera alla inkommande ärenden och kommer att kontakta dig inom kort för att hjälpa dig vidare."
                }
              ]
            }), d();
          }).catch((p) => {
            const o = y(p);
            x(o) ? t({
              type: "error",
              heading: "Misslyckades med att skicka in ärendet",
              messages: o
            }) : t({
              type: "error",
              heading: "Problem med bakomliggande system",
              messages: [
                {
                  text: "Det gick tyvärr inte att skicka in ditt ärende. Om det fortsatt inte går kontakta kundservice@preem.se."
                }
              ]
            });
          });
        },
        isPostingForm: a,
        formStatus: s
      },
      a ? "is-pending" : "default"
    ) })
  ] });
};
export {
  b as EDIFakturaForm,
  T as default
};
